// source: pbtypes/gen/joysticks/rate_limits.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_joysticks_rates_pb = require('../../../pbtypes/gen/joysticks/rates_pb.js');
goog.object.extend(proto, pbtypes_gen_joysticks_rates_pb);
goog.exportSymbol('proto.joysticks.RateLimits', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.joysticks.RateLimits = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.joysticks.RateLimits, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.joysticks.RateLimits.displayName = 'proto.joysticks.RateLimits';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.joysticks.RateLimits.prototype.toObject = function(opt_includeInstance) {
  return proto.joysticks.RateLimits.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.joysticks.RateLimits} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.joysticks.RateLimits.toObject = function(includeInstance, msg) {
  var f, obj = {
minRates: (f = msg.getMinRates()) && pbtypes_gen_joysticks_rates_pb.Rates.toObject(includeInstance, f),
maxRates: (f = msg.getMaxRates()) && pbtypes_gen_joysticks_rates_pb.Rates.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.joysticks.RateLimits}
 */
proto.joysticks.RateLimits.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.joysticks.RateLimits;
  return proto.joysticks.RateLimits.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.joysticks.RateLimits} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.joysticks.RateLimits}
 */
proto.joysticks.RateLimits.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_joysticks_rates_pb.Rates;
      reader.readMessage(value,pbtypes_gen_joysticks_rates_pb.Rates.deserializeBinaryFromReader);
      msg.setMinRates(value);
      break;
    case 2:
      var value = new pbtypes_gen_joysticks_rates_pb.Rates;
      reader.readMessage(value,pbtypes_gen_joysticks_rates_pb.Rates.deserializeBinaryFromReader);
      msg.setMaxRates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.joysticks.RateLimits.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.joysticks.RateLimits.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.joysticks.RateLimits} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.joysticks.RateLimits.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMinRates();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_joysticks_rates_pb.Rates.serializeBinaryToWriter
    );
  }
  f = message.getMaxRates();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_joysticks_rates_pb.Rates.serializeBinaryToWriter
    );
  }
};


/**
 * optional Rates min_rates = 1;
 * @return {?proto.joysticks.Rates}
 */
proto.joysticks.RateLimits.prototype.getMinRates = function() {
  return /** @type{?proto.joysticks.Rates} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_joysticks_rates_pb.Rates, 1));
};


/**
 * @param {?proto.joysticks.Rates|undefined} value
 * @return {!proto.joysticks.RateLimits} returns this
*/
proto.joysticks.RateLimits.prototype.setMinRates = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.joysticks.RateLimits} returns this
 */
proto.joysticks.RateLimits.prototype.clearMinRates = function() {
  return this.setMinRates(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.joysticks.RateLimits.prototype.hasMinRates = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Rates max_rates = 2;
 * @return {?proto.joysticks.Rates}
 */
proto.joysticks.RateLimits.prototype.getMaxRates = function() {
  return /** @type{?proto.joysticks.Rates} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_joysticks_rates_pb.Rates, 2));
};


/**
 * @param {?proto.joysticks.Rates|undefined} value
 * @return {!proto.joysticks.RateLimits} returns this
*/
proto.joysticks.RateLimits.prototype.setMaxRates = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.joysticks.RateLimits} returns this
 */
proto.joysticks.RateLimits.prototype.clearMaxRates = function() {
  return this.setMaxRates(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.joysticks.RateLimits.prototype.hasMaxRates = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.joysticks);
